import script from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=ea21445e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea21445e"]])

export default __exports__